const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.0246 16V3.99927",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 22V31H18.3398L15.9596 26.5L18.3398 22H5Z",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1147 31.0442C13.661 35.2155 18.2553 38 23.5 38C31.5081 38 38 31.5081 38 23.5C38 15.4919 31.5081 9 23.5 9C15.9908 9 9.81481 14.7082 9.0744 22.0221",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36 5V11H44.382L42.882 8L44.382 5H36Z",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5 45V20.9993",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.97369 18.0112H18.0061L18.9928 19.0343H21.9884L21.029 25.0108H24L23.0138 28.0325L21.9884 33.0376L20.0455 34.0156L24 36.0374V38.0374",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0024 9.09131V13.0547H27.01V15.9842L29.0076 18.0735L29.9508 22.0181L33.9593 24.0779L34.9918 20.9915H37.9911",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M8.13818 43.9289C11.1269 45.2569 14.4706 46 18 46C30.7025 46 41 36.3741 41 24.5C41 19.4514 39.1385 14.8093 36.0221 11.1406",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeDasharray: "2 2"
});
function SvgSimplicity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplicity);
export default __webpack_public_path__ + "static/media/simplicity.aac9e598.svg";
export { ForwardRef as ReactComponent };